// import BiofluxDeviceIcon from './assets/bioflux-device-icon.svg';
// import BiotresDeviceIcon from './assets/biotres-device-icon.svg';
// import BiotresDeviceV2Icon from './assets/biotres-device-v2-icon.svg';
// import OnlyLogoIcon from './assets/only-logo-icon.svg';
import { useCallback } from 'react';
import { t } from 'ttag';
import LearnMoreModal from './learnMoreModal/learnMoreModal';
import { CONSULTING_REQUEST_TYPE } from '../config/learnMoreModal';
import BiocareLogo from './assets/biocare-logo.svg';
import { useMarketingBanner } from './useMarketingBanner';
import LearnMoreUniversalCiedManagementModal from './learnMoreUniversalCiedManagementModal/learnMoreUniversalCiedManagementModal';
import './styles.scss';

/**
 * Rotating marketing banner shown above the workspace together with the two learn-more modals it opens. Takes state and the toggle callbacks from useMarketingBanner, mounts LearnMoreUniversalCiedManagementModal and LearnMoreModal typed as Bioflux trade-in or RPM/CCM service depending on which banner was clicked, and delegates the visible slide to renderBackground.
 *
 * @returns The rendered banner and modal elements.
 */
const MarketingBanner = () => {
  const {
    state,
    toggleLearnMoreUniversalCiedManagementModal,
    toggleLearnMoreModal,
    onClickContent,
  } = useMarketingBanner();

  /**
   * Renders the marketing banner slide selected by state.backgroundIndex. Index 0 gives the Biocare implantable device management teaser and index 1 the RPM plus CCM revenue slide, each forwarding its own clicked-banner flag to onClickContent, while any other index renders nothing; the callback is memoized on backgroundIndex.
   *
   * @returns The rendered slide element, or null.
   */
  const renderBackground = useCallback(() => {
    switch (state.backgroundIndex) {
      case 0: {
        return (
          <div
            className="marketing-banner --second"
            onClick={() => {
              onClickContent({ isClickedUniversalCiedManagementBannder: true });
            }}
            aria-hidden="true"
          >
            <div className="text-container">
              <div className="title">{t`COMING SOON TO YOUR`}</div>
              <img className="biocare-logo" src={BiocareLogo} alt="Biocare logo" />
              <div className="title">{t`WORKSPACE`}</div>
            </div>

            <div className="separator" />

            <div className="text-container">
              <div className="title">{t`IMPLANTABLE DEVICE MANAGEMENT `}</div>
            </div>

            <div className="separator" />

            <div className="text-container">
              <div className="learn-more">{t`Click Here to Learn More`}</div>
            </div>
          </div>
        );
      }
      // case 2: {
      //   return (
      //     <div
      //       className="marketing-banner --third"
      //       onClick={() => {
      //         onClickContent({ isClickedBiofluxTradeInBanner: true });
      //       }}
      //       aria-hidden="true"
      //     >
      //       <img
      //         className="bioflux-device-icon"
      //         src={BiofluxDeviceIcon}
      //         alt="Bioflux device icon"
      //       />

      //       <button className="text-container">
      //         <div className="text-container__left">
      //           <img
      //             src={OnlyLogoIcon}
      //             alt="Only logo icon"
      //           />
      //           <div className="title">
      //             {t`Trade In`}
      //           </div>
      //           <div className="sub-title">
      //             |  Trade Up  |  Pre Order  |  Save
      //           </div>
      //         </div>

      //         <div className="learn-more">
      //           {t`Click here for more info`}
      //         </div>
      //       </button>

      //       <img
      //         className="biotres-device-icon"
      //         src={BiotresDeviceIcon}
      //         alt="Biotres device icon"
      //       />
      //     </div>
      //   );
      // }
      case 1: {
        return (
          <div
            className="marketing-banner --final"
            onClick={() => {
              onClickContent({ isClickedRpmCcmServiceBanner: true });
            }}
            aria-hidden="true"
          >
            <div className="text-container">
              <div className="title">{t`ONE LOGIN`}</div>
              <div className="part-wall" />
              <div className="title">{t`RPM + CCM = better outcomes`}</div>
            </div>

            <img className="biocare-logo" src={BiocareLogo} alt="Biocare logo" />

            <div className="text-container">
              <div className="title">{t`INCREASED REVENUE`}</div>
              <div className="part-wall" />
              <div className="learn-more">{t`Click to learn more`}</div>
            </div>
          </div>
        );
      }
      default: {
        return null;
        // return (
        //   <div
        //     className="marketing-banner --first"
        //     aria-hidden="true"
        //   >
        //     <div className="text-container">
        //       <div className="title">
        //         {t`SAY HELLO TO`}
        //       </div>
        //       <div className="title biocore-color">
        //         BIOCORE
        //       </div>
        //       <img
        //         className="biotres-device-icon"
        //         src={BiotresDeviceV2Icon}
        //         alt="Biotres device icon"
        //       />
        //       <div className="title">
        //         {t`THE DEVICE FORMERLY KNOWN AS`}
        //       </div>
        //       <div className="title biocore-color">
        //         BIOTRES
        //       </div>
        //       <img
        //         className="biotres-device-logo"
        //         src={BiotresDeviceV2Icon}
        //         alt="Biotres device icon"
        //       />
        //     </div>
        //   </div>
        // );
      }
    }
  }, [state.backgroundIndex]);

  return (
    <>
      <LearnMoreUniversalCiedManagementModal
        open={state.isOpenLearnMoreUniversalCiedManagementModal}
        handleClickCloseButton={toggleLearnMoreUniversalCiedManagementModal}
      />
      <LearnMoreModal
        open={state.isOpenLearnMoreModal}
        onCancel={toggleLearnMoreModal}
        type={
          state.isClickedBiofluxTradeInBanner
            ? CONSULTING_REQUEST_TYPE.BIOFLUX_TRADE_IN
            : CONSULTING_REQUEST_TYPE.RPM_CCM_SERVICE
        }
      />

      <div className="marketing-banner-container">
        <div className="empty-div" />
        {renderBackground()}
      </div>
    </>
  );
};

export default MarketingBanner;
